/* eslint-disable */

import request from '@/utils/request'

export function getListShiftApi(query) {
  return request({
    url: '/config-service/v1/housekeeping-shift',
    method: 'get',
    params: query
  })
}
export function getShiftByIdApi(id) {
  return request({
    url: `/config-service/v1/housekeeping-shift/${id}`,
    method: 'get'
  })
}
export function getDefaultTransactionApi() {
  return request({
    url: '/config-service/v1/special-service/special-service/transaction',
    method: 'get',
    params: {
      transaction_group: 1
    }
  })
}

export function addShiftApi(query) {
  return request({
    url: '/config-service/v1/housekeeping-shift',
    method: 'post',
    data: query
  })
}

export function updateShiftApi(query) {
  return request({
    url: `/config-service/v1/housekeeping-shift/${query.id}`,
    method: 'put',
    data: query
  })
}
export function deleteShiftApi(query) {
  return request({
    url: '/config-service/v1/housekeeping-shift',
    method: 'delete',
    data: query
  })
}
